import { forwardRef } from 'react';

import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';

export type TextFieldProps = Omit<MuiTextFieldProps, 'ref'> & {
  shrink?: boolean;
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ shrink = true, InputLabelProps, ...props }, ref) => (
    <MuiTextField {...props} InputLabelProps={{ shrink, ...InputLabelProps }} inputRef={ref} />
  ),
);

TextField.displayName = 'TextField';
